export const capitalize = function () {
  return function(string) {
    if (!string) return null;
    return _.capitalize(string);
  };
};
